const MAX_REMIX_ALT_LENGTH = 510;

/**
 * Resolves the alt text for a Remix infographic image.
 *
 * Returns the trimmed alt, capped at 510 code points (a surrogate pair is never split).
 * Returns `undefined` for "no alt": missing, `null`, blank, or a non-string value at runtime.
 * On insert the caller then sets no alt; on replace it clears the old alt.
 */
export const resolveRemixAlt = (altText: string | null | undefined): string | undefined => {
	// The payload is parsed from streamed JSON, so guard against non-strings at runtime.
	const trimmed = typeof altText === 'string' ? altText.trim() : '';
	if (!trimmed) {
		return undefined;
	}
	const codePoints = Array.from(trimmed);
	return codePoints.length <= MAX_REMIX_ALT_LENGTH
		? trimmed
		: codePoints.slice(0, MAX_REMIX_ALT_LENGTH).join('');
};
